info<template>
    <div class="wrap">
        <div
            class="rr"
            id="sy"
        >
            <div :class="['header', { 'scrolled': isScrolled }]">
                <div class="img">
                    <img
                        src="@/assets/logo.png"
                        alt=""
                        class="logo"
                    >
                </div>
                <div class="right">
                    <n-split :default-size="0.9">
                        <template #1>
                            <n-menu
                                v-model:value="activeKey"
                                mode="horizontal"
                                :options="menuOptions"
                                responsive
                            />
                        </template>
                    </n-split>
                </div>
            </div>
            <div class="s-first-section-arrow s-section-shape css-ujp6is">
                <div class="shape1"></div>
                <div class="shape2"></div>
            </div>
        </div>
        <div class="menu1">
            <div
                class="m1"
                id="cx"
            >
                <div class="title">
                    各种自助可扫码车型
                </div>
                <div class="des">
                    总有一款适合您......
                </div>
                <div class="innerlist">
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FuWK-uyTeUia3Akte_EfexTPhX3I.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享泡泡机</div>
                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/Fq2keKRGC_81Q9PoM1DXyIZdn_Vu.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">VR时空剧场</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FoAL6Nvw_H0V9zJPhfxHlXQ1DUH6.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享挖掘机</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FpU2yMb9DsRaF6NL5jsB8RLWYyVO.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">VR共享设备</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FgzzzEK5rWJVluTcRmKCDoiZnMFt.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">履带式小坦克</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FvqUf8h0lwJbtCvdcjJ1BNFW_TBI.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享沙滩车</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FraVn5326j2JGwRfcCPBqx3YABPG.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享仿电动小跑车</div>

                    </div>
                    <div class="item">
                        <img
                            src="@/assets/1.jpg"
                            alt=""
                        >
                        <div class="text">共享宠物自行车</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/Fprmyyd24vSPrKajDH_XMFbEMSDV.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享童车</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FrgIfd-XPp7dyGd22hJTM-K9_eb9.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">亲子卡丁车</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/Fo6xVPKruHmjOmKbH-O9wFoZTPeY.jpg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/quality/90!/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">景区共享情侣车</div>

                    </div>
                    <div class="item">
                        <img
                            src="./assets/car.jpg"
                            alt=""
                        >
                        <div class="text">助力山地车</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FoRftigNTLtXQQj9mEjXriibAFSi.jpeg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/quality/90!/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享四人观光车</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/Ft-8LWvdllvJeE6xBMJYTo2ja0xM.jpeg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享电动三轮</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FhY-vxAmC7kMJyWr4Kux1rcAAcQY.jpeg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">共享亲子电动车</div>

                    </div>
                    <div class="item">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FrsQsApLsLZHy7Yv3zYQbqvGJDzE.jpeg?imageMogr2/strip/auto-orient/thumbnail/500x1000%3E/quality/90!/interlace/1/format/jpeg"
                            alt=""
                        >
                        <div class="text">扫码公园游船</div>

                    </div>
                </div>
            </div>
            <div
                class="m2"
                id="ys"
            >
                <div class="title">
                    产品优势
                </div>
                <div class="des">
                    自助、智能、省成本、可定点或多点取还车
                </div>
                <div class="img">
                    <img
                        src="https://user-assets.sxlcdn.com/images/75611/FhMfvGrxIJzXAdnXAKJGTbj3TyRt.jpeg?imageMogr2/strip/auto-orient/thumbnail/1200x9000%3E/quality/90!/interlace/1/format/jpeg"
                        alt=""
                    >
                </div>
            </div>
            <div
                class="m21"
                id="cs"
            >
                <div class="title">
                    智能车锁
                </div>
                <div class="des">
                    防拆卸设计 太阳能供电
                </div>
                <div class="des">
                    无需下载APP 超强续航能力
                </div>
                <div class="des">
                    小程序开锁方案 支持定点取还车
                </div>
                <div class="img">
                    <img
                        src="https://user-assets.sxlcdn.com/images/75611/Fu0PDhPUBxXegkCqwmH_MHTyQKj-.jpg?imageMogr2/strip/auto-orient/thumbnail/1200x9000%3E/quality/90!/interlace/1/format/jpeg"
                        alt=""
                    >
                </div>
            </div>

            <div class="m22">
                <div class="title">
                    联网控制器
                </div>
                <div class="des">
                    改造传统传感器/PLC/变频器等
                </div>
                <div class="des">
                    可实现快速联接，无需部署新设备
                </div>
                <div
                    class="des"
                    style="font-style: italic;"
                >
                    灵活部署，有效降低用户改造、部署、维护成本
                </div>
                <div class="img">
                    <img
                        src="https://user-assets.sxlcdn.com/images/75611/FgrNQA3L7lVJx-_qiTOdc2bdm2no.png?imageMogr2/strip/auto-orient/thumbnail/1200x9000%3E/format/png"
                        alt=""
                    >
                </div>
            </div>
            <div
                class="m21"
                id="gl"
            >
                <div class="title">
                    平台化管理
                </div>
                <div class="des">
                    轻松解决运营烦恼
                </div>

                <div class="img">
                    <img
                        src="https://user-assets.sxlcdn.com/images/75611/FhYacG1yS1Tc8LlqfhSvBxqHkd0u.png?imageMogr2/strip/auto-orient/thumbnail/1200x9000%3E/quality/90!/format/png"
                        alt=""
                    >
                </div>
            </div>
            <div class="m21">

                <div
                    class="img"
                    style="margin-bottom: 50px;"
                >
                    <img
                        src="https://user-assets.sxlcdn.com/images/75611/FhBoB4K2tb8NM4yTNrwxxpMjZ3RN.jpg?imageMogr2/strip/auto-orient/thumbnail/1200x9000%3E/quality/90!/interlace/1/format/jpg"
                        alt=""
                    >
                </div>
                <div class="des1">
                    车辆管理 — 查看所有车辆、远程管理车辆
                </div>
                <div class="des1">
                    订单管理 — 查看订单详情、订单统计筛选
                </div>
                <div class="des1">
                    财务管理 — 支持自动提现、随时查看收入
                </div>
            </div>
            <div
                class="m3"
                id="al"
            >
                <div class="title">
                    景区合作案例
                </div>
                <div class="des">
                    更多景区合作中......
                </div>
                <div class="listu">
                    <div class="itemu">
                        <div class="textu">浙江东阳横店影视城</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">苏州太湖园博园景区</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">龟山湖旅游风景区</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">金湖水上森林景区</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">杭州西湖风景区</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">江苏省动物园</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">海南天涯海角</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">南通黄金海滩风景区</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">江苏南京森林景区</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">湖南永州古瑶部落花海景区</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">已有车型改造</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">上海上房梦花源</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">湖北荆州园博园</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">福建厦门园林博览苑</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">湖北恩施爱情小镇</div>
                    </div>
                    <div class="itemu">
                        <div class="textu">安徽凤阳大明遗址公园</div>
                    </div>
                </div>
            </div>
            <div
                class="code"
                id="lx"
            >
                <div class="des">
                    加微信索要合作资料
                </div>
                <div class="des">
                    （长按识别下方二维码）
                </div>
                <div class="codepic">
                    <div class="img">
                        <img
                            src="https://user-assets.sxlcdn.com/images/75611/FlXucUUOPLRUSuwWMIfto3_X7vRD.jpg?imageMogr2/strip/auto-orient/thumbnail/720x1440%3E/quality/90!/interlace/1/format/jpeg"
                            alt=""
                        >
                    </div>
                </div>
            </div>
            <div class="m4">
                <div class="title">
                    联系我们
                </div>
                <div class="des">
                    赶紧联系我们吧。和我们一起，激发无限创造力
                </div>
                <div class="contentInput">
                    <input
                        type="text"
                        v-model="username"
                        placeholder="贵姓"
                    >
                    <input
                        type="text"
                        v-model="companyName"
                        placeholder="联系方式"
                    >
                    <textarea
                        placeholder="景区名称"
                        v-model="content"
                        class="xxdes"
                        rows="4"
                    ></textarea>
                </div>
                <div class="but">
                    <button @click="asEmail">提交</button>
                </div>
            </div>

        </div>
        <div class="footer">
            <div class="company-info">
                <p>公司地址：上海市闵行区莘北路505号东阔颐园B座4楼</p>
                <p>商务邮箱：xiatao@flashbike.cn</p>
                <p>客服热线：400-900-7756（工作日08:00-20:00）</p>
                <p>&copy; 上海新滔信息技术有限公司版权所有</p>

                <div class="footer-bottom">
                    <div class="icp-info">
                        <img
                            class="psb-icon"
                            src="https://static-assets.sxlcdn.com/images/landing-sxl/gongan-beian.png"
                        >
                        <span>沪公网安备31011202008388号</span>
                        <span>|</span>
                        <span>沪ICP备17000108号-1</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { h, ref, onMounted, onUnmounted } from 'vue'


const isScrolled = ref(false);
const username = ref('');
const companyName = ref('');
const content = ref('');
const handleScroll = () => {
    if (window.scrollY > 0) {
        isScrolled.value = true;
    } else {
        isScrolled.value = false;
    }
};

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
    Object.values(sectionMap).forEach(id => {
        const el = document.getElementById(id)
        if (el) observer.observe(el)
    })
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
const asEmail = async () => {
    if (!username.value || !companyName.value || !content.value) {
        alert('请填写完整信息');
        return;
    }

    const res = await fetch('https://shared.kuangbiaobike.cn/manage/contactUs', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            username: username.value,
            companyName: companyName.value,
            content: content.value
        })
    })
    console.log(res);
    alert('提交成功，我们会尽快与您联系！');
    username.value = '';
    companyName.value = '';
    content.value = '';

}

// 菜单选项
const menuOptions = [
    //   {
    //     label: () =>
    //       h(
    //         'a',
    //         {
    //           href: 'https://baike.baidu.com/item/%E4%B8%94%E5%90%AC%E9%A3%8E%E5%90%9F',
    //           target: '_blank',
    //           rel: 'noopenner noreferrer'
    //         },
    //         '且听风吟'
    //       ),
    //     key: 'hear-the-wind-sing',
    //   },
    {
        label: '首页',
        key: 'sy',
        onClick: () => {
            scrollToSection('sy')
        }
    },
    {
        label: '车型',
        key: 'cx',
        onClick: () => {
            scrollToSection('cx')

        }
    },
    {
        label: '优势',
        key: 'ys',
        onClick: () => {
            scrollToSection('ys')

        }

    }, {
        label: '车锁',
        key: 'cs',
        onClick: () => {
            scrollToSection('cs')

        }

    },
    {
        label: '管理',
        key: 'gl',
        onClick: () => {
            scrollToSection('gl')

        }
    },
    {
        label: '案例',
        key: 'al',
        onClick: () => {
            scrollToSection('al')

        }

    }, {
        label: '联系方式',
        key: 'lx',
        onClick: () => {
            scrollToSection('lx')
        }

    },
    {
        label: () =>
            h(
                'a',
                {
                    href: 'http://admin.flashbike.cn/admin/login.jhtml',
                    target: '_blank',
                    rel: 'noopenner noreferrer'
                },
                '商户登录'
            ),
        onClick: () => {
            activeKey.value = null
        }
    },
    {
        label: () =>
            h(
                'div',
                {
                    class: 'hotline-btn'
                },
                [
                    '服务热线 400-900-7756',
                ]
            ),
        onClick: () => {
            activeKey.value = null
        }

    }
]
const sectionMap = {
    sy: 'sy',       // 对应页眉
    cx: 'cx',           // 车型
    ys: 'ys',           // 优势
    cs: 'cs',          // 车锁
    gl: 'gl',          // 管理（同m21）
    al: 'al',           // 案例
    lx: 'lx'          // 联系方式
}
const scrollToSection = (key) => {
    const sectionId = sectionMap[key]
    const target = document.querySelector(`#${sectionId}`)
    if (target) {
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
    }
}

// 初始化Intersection Observer
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const visibleKey = Object.keys(sectionMap).find(
                key => sectionMap[key] === entry.target.id
            )
            if (visibleKey) activeKey.value = visibleKey
        }
    })
}, {
    threshold: 0.5,  // 50%可见时触发
    rootMargin: '-50px 0px -50px 0px' // 调整检测区域
})

// 组件的响应式数据
const activeKey = ref(null)
</script>

<style lang="scss">
.wrap {
    .rr {
        position: relative;
        height: 100vh;
        width: 100%;
        background-image: url("@/assets/bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-color: transparent;
        background-position: center;
        background-attachment: fixed;

        // 移动端兼容：移除 fixed 背景，用伪元素代替
        @media (max-width: 768px) {
            background-attachment: scroll; // 显式取消 fixed
            background-image: none; // 隐藏原背景图，防止叠图
        }

        // 添加移动端兼容的背景图层
        &::before {
            content: "";
            display: none; // 默认隐藏，仅移动端显示
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 80vh;
            z-index: -1;
            background-image: url("@/assets/bg.jpeg");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-color: transparent;
        }

        @media (max-width: 768px) {
            &::before {
                display: block;
            }
        }
    }

    .header {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        width: 100%;
        z-index: 10;

        &.scrolled {
            background-color: white;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px;
        }

        .img {
            max-width: 240px;
            min-width: 240px;

            .logo {
                width: 100%;
                max-height: 60px;
            }
        }

        .right {
            flex: 0.8;
            display: flex;
            justify-content: flex-end;

            .hotline-btn {
                background-color: #35ccc3;
                padding: 6px 14px;
                border-radius: 6px;
                font-size: 16px;
                font-weight: 700;
                color: #000;
                display: inline-block;
                user-select: none;
            }
        }
    }
}

.n-split__resize-trigger-wrapper {
    display: none !important;
}

.n-split-pane-2 {
    display: none;
}

.n-split {
    justify-content: flex-end;
}

.v-overflow {
    justify-content: flex-end !important;
    font-family: "Open Sans", "open_sans", "Lucida Grande", "Verdana",
        "Pingfang SC", "Pingfang TC", "Hiragino Sans GB", "Microsoft YaHei",
        Cardo, STSong, "Songti SC", SimSun, "PingFang SC", "Microsoft YaHei",
        微软雅黑, STXihei, 华文细黑, serif;
    font-weight: bold;
    font-size: 16px;
}

.s-first-section-arrow {
    list-style: none;
    font-weight: 400;
    font-size: 100%;
    line-height: 1;
    font-family: inherit;
    font-style: normal !important;
    position: absolute;
    bottom: 0px;
    left: 0px;
    height: 25px;
    width: 100%;
    z-index: 9;

    .shape1 {
        list-style: none;
        font-weight: 400;
        font-size: 100%;
        line-height: 1;
        font-family: inherit;
        font-style: normal !important;
        position: absolute;
        bottom: 0px;
        width: 50%;
        height: 0px;
        box-sizing: border-box;
        left: 0px;
        border-right-color: transparent !important;
        border-width: 0px 25px 25px;
        border-color: rgb(255, 255, 255);
        border-style: solid;
    }

    .shape2 {
        list-style: none;
        font-weight: 400;
        font-size: 100%;
        line-height: 1;
        font-family: inherit;
        font-style: normal !important;
        position: absolute;
        bottom: 0px;
        width: 50%;
        height: 0px;
        box-sizing: border-box;
        right: 0px;
        border-left-color: transparent !important;
        border-width: 0px 25px 25px;
        border-color: rgb(255, 255, 255);
        border-style: solid;
    }
}

.menu1 {
    background-color: white;

    position: relative;
    padding: 75px 0;
    font-family: Cardo, STSong, Songti SC, SimSun, "PingFang SC",
        "Microsoft YaHei", "微软雅黑", STXihei, "华文细黑", sans-serif;

    .m4 {
        width: 800px;
        margin: 0 auto;
        margin-top: 30px;

        .title {
            text-align: center;
            font-size: 36px;
            margin-bottom: 10px;
        }

        .des {
            text-align: center;
            color: rgb(57, 178, 167);
            font-size: 20px;
        }

        .contentInput {
            margin: 0 auto;
            margin-top: 60px;
            width: 400px;
            display: flex;
            flex-direction: column;

            input {
                height: 40px;
                margin-bottom: 20px;
                font-size: 16px;
                border-radius: 10px;
                outline: none;
                border: 1px solid #ccc;
                padding-left: 10px;
            }

            .xxdes {
                font-size: 16px;
                padding-top: 10px;
                border-radius: 10px;
                outline: none;
                border: 1px solid #ccc;
                padding-left: 10px;
            }
        }

        .but {
            display: flex;
            justify-content: center;
        }

        button {
            background-color: rgb(57, 178, 167);
            height: 40px;
            width: 80px;
            border-radius: 10px;
            color: black;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            border: none;
            margin: 0 auto;
            cursor: pointer;
            margin-top: 10px;
        }
    }

    .code {
        max-width: 800px;
        margin: 0 auto;
        margin-top: 60px;

        .des {
            text-align: center;
            color: rgb(57, 178, 167);
            font-size: 18px;
            margin-top: 40px;
        }

        .codepic {
            display: flex;
            justify-content: center;
            margin-top: 40px;

            .img {
                max-width: 478px;
                max-height: 478px;
                display: flex;
                justify-content: center;
            }

            img {
                width: 80%;
            }
        }
    }

    .m3 {
        max-width: 800px;
        margin: 0 auto;
        margin-top: 70px;

        .title {
            text-align: center;
            font-size: 36px;
            margin-bottom: 10px;
        }

        .des {
            text-align: center;
            color: rgb(57, 178, 167);
            font-size: 20px;
        }

        .listu {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 50px;

            .itemu {
                width: 24%;
                height: 250px;
                background-size: cover;
                background-position: center;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 10px;

                // 蒙层
                &::before {
                    content: "";
                    position: absolute;
                    inset: 0; // 等同于 top: 0; right: 0; bottom: 0; left: 0;
                    background-color: rgba(0,
                            0,
                            0,
                            0.4); // 黑色半透明，可以根据需要调整透明度
                    z-index: 1;
                }

                .textu {
                    width: 80%;
                    white-space: pre-wrap;
                    text-align: center;
                    position: relative;
                    z-index: 2;
                    color: white;
                }

                &:nth-child(1) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FntDtKkM4cqOyB5_uhFZ1zjsLFUc.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpg);
                }

                &:nth-child(2) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/lk_pYPnEZCy19ml3pod1rs1CS0fY.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(3) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/ljXtpSzJBtpJZ8AZ9Cj1bcEZ_jin.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(4) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FmVeIl8DOKte76rkylm7XIPbt8nw.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(5) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FpKd3DPZ3tjHJ7Cmg6RMKCSwoAe0.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(6) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/Fu73oNl2klviaET_LkZHWWKYjVI8.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(7) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FjqOna2gg5yy9tCHK63FAiVhwBB0.png?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/format/png);
                }

                &:nth-child(8) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/lqpFRK-WiNKtJePGqbR2qU1Rw8gV.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(9) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FoP6QNRTuhyAyzWPgpCphB6NPWws.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(10) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FnD_dag9B6AE7IBNnhS4S5jO1UNN.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(11) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FjER3WlfYY9HKiYlJ7HnOGpzhxbi.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(12) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FuFAtDBe3e7hS0C4rWVJ3aJmdoNJ.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(13) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/Fh2Z_Fa4YbpCzgqlcilO7rPz85dL.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(14) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/Fj9vucVHeH1qs4NbScDYA-WHKQeC.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(15) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/Fsxxow7PzlCS28VekYPAPZThY9gV.jpeg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }

                &:nth-child(16) {
                    background-image: url(https://user-assets.sxlcdn.com/images/75611/FtsPdzltUBDfFdCoqQLjd8lGiQLe.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpeg);
                }
            }
        }
    }

    .m1 {
        max-width: 800px;
        margin: 0 auto;

        .title {
            text-align: center;
            font-size: 36px;
            margin-bottom: 10px;
        }

        .des {
            text-align: center;
            color: rgb(57, 178, 167);
            font-size: 20px;
        }

        .innerlist {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .item {
                margin-bottom: 50px;
                width: 22%;
                position: relative;

                img {
                    width: 100%;
                }

                .text {
                    font-size: 18px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    text-align: center;
                    font-family: Open Sans, Lucida Grande, Verdana, Pingfang SC,
                        Pingfang TC, Hiragino Sans GB, Microsoft YaHei,
                        sans-serif, "PingFang SC", "Microsoft YaHei", "微软雅黑",
                        STXihei, "华文细黑", sans-serif;
                }
            }
        }
    }

    .m2 {
        max-width: 800px;
        margin: 0 auto;
        margin-top: 60px;

        .title {
            text-align: center;
            font-size: 36px;
            margin-bottom: 10px;
        }

        .des {
            text-align: center;
            color: rgb(57, 178, 167);
            font-size: 20px;
        }

        .img {
            margin-top: 20px;
            max-height: 425px;
            width: 100%;

            img {
                height: 100%;
                width: 100%;
            }
        }
    }

    .m21 {
        max-width: 800px;
        margin: 0 auto;
        margin-top: 60px;

        .title {
            text-align: center;
            font-size: 36px;
            margin-bottom: 10px;
        }

        .des {
            text-align: center;
            color: rgb(57, 178, 167);
            font-size: 20px;
        }

        .des1 {
            text-align: center;
        }

        .img {
            margin-top: 20px;
            max-height: 425px;
            width: 100%;

            img {
                height: 100%;
                width: 100%;
            }
        }
    }

    .m22 {
        max-width: 800px;
        margin: 0 auto;
        margin-top: 60px;

        .title {
            text-align: center;
            font-size: 36px;
            margin-bottom: 10px;
        }

        .des {
            text-align: center;
        }

        .img {
            margin: 0 auto;
            margin-top: 20px;
            max-height: 220px;
            max-width: 230px;

            img {
                width: 100%;
            }
        }
    }


}

.footer {
    background-color: white;
    overflow: hidden;

    .company-info {
        max-width: 600px;
        margin: 20px auto;
        padding: 20px;
        font-family: Arial, sans-serif;
        color: #333;
        line-height: 1.6;
        text-align: center;
    }

    .company-info p {
        margin: 8px 0;
    }

    .contact-link {
        color: #0066cc;
        text-decoration: none;
    }

    .contact-link:hover {
        text-decoration: underline;
    }

    .footer-bottom {
        margin-top: 15px;
        padding-top: 10px;
        border-top: 1px solid #eee;
        font-size: 0.9em;
        color: #666;
    }

    .icp-info {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 8px;
    }
}

// @media (max-width: 575.98px) { ... }

// // Small devices (landscape phones, 576px and up)

// // Medium devices (tablets, 768px and up)
// @media (min-width: 768px) and (max-width: 991.98px) { ... }

// // Large devices (desktops, 992px and up)
// @media (min-width: 992px) and (max-width: 1199.98px) { ... }

// // Extra large devices (large desktops, 1200px and up)
// @media (min-width: 1200px) { ... }
/* 小屏手机（max 480px） */
@media screen and (max-width: 480px) {
    .innerlist .item {
        margin-bottom: 50px;
        width: 44% !important;

        img {
            width: 100%;
        }
    }

    .m3 .itemu {
        width: 100% !important;
    }

    .header {
        display: none !important;
    }
}

/* 普通手机（max 768px） */
@media screen and (max-width: 768px) {
    .innerlist .item {
        margin-bottom: 50px;
        width: 44% !important;

        img {
            width: 100%;
        }
    }

    .m3 {
        padding: 0 20px;
        box-sizing: border-box;
    }

    .m3 .itemu {
        width: 100% !important;
    }

    .header {
        display: none !important;
    }

    .rr {
        height: 75vh !important;
    }
}
</style>
